// 导入所需的模块和函数
import { BsTrack, BsUtil } from 'dida-web-common'
import DATA from './../pageConf.js'

// 初始化通用参数对象，从URL中解析channelId和channelSceneId
const commonParams = {}

// 尝试从配置文件中读取并注入动态参数
try {
  const logParams = DATA?.options.basic.logParams ?? []
  logParams.forEach(({ key }) => {
    const [paramKey, paramValue] = key.split('=')
    if (paramValue.startsWith('${') && paramValue.endsWith('}')) {
      // 动态参数，从URL中解析
      const queryKey = paramValue.slice(2, -1)
      const value = BsUtil.queryString(queryKey)
      if (value) {
        commonParams[paramKey] = value
      }
    } else {
      // 静态参数，直接赋值
      commonParams[paramKey] = paramValue
    }
  })
} catch (error) {
  // 改进错误处理，打印更详细的错误信息
  console.error('Error initializing tracking parameters:', error)
}

// 导出异步函数，用于创建并返回BsTrack实例
export default function createTracker(name, sceneCode = '', activityCode = '') {
  try {
    // 异步获取客户端ID
    // const { cid } = await BsGetCid()

    // 创建并返回BsTrack实例
    return new BsTrack(
      { name, sceneCode, activityCode },
      { ...commonParams }
    )
  } catch (error) {
    // 改进错误处理，打印更详细的错误信息
    console.error('Error creating tracker:', error)
    // 可以根据需要抛出错误或返回null/undefined
  }
}
